import { NavItemType } from 'types/menu';
import templates from './templates';
import tags from './tags';
import reports from './reports';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [templates, tags, reports]
};

export default menuItems;
